const laboratoryFieldGroups = {
  mandatory: ['docket_number', 'reference_number', 'compressive_strength'],
};

export default laboratoryFieldGroups;
